import { Action } from 'redux';
import {
    HighlightIndexType,
    IParagraphClause,
} from '../../../../Contract/Contract-types';
import { IFeatureToggle } from '../../../../FeatureToggleProvider/FeatureToggleProvider-types';
import { IContractParagraph } from '../../../../Paragraph/Paragraph-types';
import { IPropertySuggestion } from './ParagraphSuggestion/ParagraphSuggestion-types';
import { ContractIssue } from '@thought-river/negotiations-common';
import { setBannerSettingsAction } from '../../../../HeatmapPane/HeatmapPane-actions';

export const PAGE_SIZE = 10;
export const LOAD_MORE_SUGGESTIONS_DISTANCE = 32;

export const RESET_SUGGESTIONS = 'RESET_SUGGESTIONS';
export const SET_LOADING_SUGGESTIONS = 'SET_LOADING_SUGGESTIONS';
export const SET_SUGGESTIONS_INITIAL_LOAD_COMPLETED =
    'SET_SUGGESTIONS_INITIAL_LOAD_COMPLETED';
export const SET_SUGGESTIONS = 'SET_SUGGESTIONS';

export interface IParagraphSuggestionsReducer {
    nextPageNumber: number;
    suggestions: IPropertySuggestion[];
    count: number;
    loading: boolean;
    initialLoadCompleted: boolean;
}

export interface IResetSuggestionsAction extends Action {
    type: typeof RESET_SUGGESTIONS;
}

export interface ISetSuggestionsInitialLoadCompletedAction extends Action {
    type: typeof SET_SUGGESTIONS_INITIAL_LOAD_COMPLETED;
    initialLoadCompleted: boolean;
}

export interface ISetLoadingSuggestionsAction extends Action {
    loading: boolean;
    type: typeof SET_LOADING_SUGGESTIONS;
}

export interface ISetSuggestionsAction extends Action {
    count?: number;
    nextPageNumber?: number;
    suggestions: IPropertySuggestion[];
    type: typeof SET_SUGGESTIONS;
}

export interface IParagraphSuggestionsDispatchProps {
    resetSuggestions: () => void;
    setHighlightIndex: (
        index: number,
        highlightType: HighlightIndexType
    ) => void;
    setSelectedIssue: (issue: ContractIssue) => void;
    setSelectedParagraph: (paragraph: IContractParagraph) => void;
    setSuggestions: (
        suggestions: IPropertySuggestion[],
        nextPageNumber?: number,
        count?: number
    ) => void;
    setSuggestionsInitialLoadCompleted: (loaded: boolean) => void;
    setSuggestionsLoading: (loading: boolean) => void;
    updateIssue: (issue: ContractIssue) => void;
    setBannerSettings: typeof setBannerSettingsAction;
}

export interface IParagraphSuggestionsStateProps {
    count: number;
    featureToggles: IFeatureToggle[];
    highlightedParagraphs: IContractParagraph[];
    initialLoadCompleted: boolean;
    issue: ContractIssue;
    loading: boolean;
    nextPageNumber: number;
    paragraphs: IContractParagraph[];
    streamCode: string;
    suggestions: IPropertySuggestion[];
}

export interface IParagraphSuggestionsBaseProps {
    clauseNumbers: IParagraphClause[];
}

export interface IParagraphSuggestionsState {
    editedSuggestionId: string;
}

export type IParagraphSuggestionsProps = IParagraphSuggestionsBaseProps &
    IParagraphSuggestionsDispatchProps &
    IParagraphSuggestionsStateProps;

export type IParagraphSuggestionsActionTypes =
    | IResetSuggestionsAction
    | ISetLoadingSuggestionsAction
    | ISetSuggestionsAction
    | ISetSuggestionsInitialLoadCompletedAction;
